const passkey_sign_in = {
    setup_page: {
        title: '简化你的登录',
        subtitle: '创建通行密钥',
        description: '使用设备生物识别、YubiKey 等安全密钥或其他可用方式注册你的通行密钥。',
    },
    trigger_conditional_ui_failed: '未能触发 Passkey 自动填充。',
};
export default Object.freeze(passkey_sign_in);
